import { Col, Row, Card, Badge, Button, Nav, Tab } from "react-bootstrap";
import { FiUser, FiCalendar, FiEdit } from "react-icons/fi";
import DetailsPageNavigation from "../../views/dashboard/widget/detailsPageNavigation";
import placeHolder from "../../assets/images/placeHolderProfile.jpg";
import {
  getClassDetails,
  getDivisionSectionList,
  deleteDivisionSection,
  updateDivisionSectionStatus,
  updateClassStatus,
  deleteClass,
  updateClass,
  getSubjectList,
  updateSubjectStatus,
  deleteTutor,
  updateTutorStatus,
  getTutorList,
  deleteSubject,
} from "../../services/Academic-Services";
import AddDivisionSectionForm from "../FormComponents/AddDivisionSection";
import AddTutorForm from "../FormComponents/AddTutor";
import AddSubjectForm from "../FormComponents/AddSubject";

import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { getMethods, showErrorMessages } from "../../services/utilityFunctions";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../../services/hostelConst";
import MasterActions from "../../views/dashboard/widget/MasterActions";
import AddClassesForm from "../FormComponents/AddClasses";
import MasterTable from "../../views/dashboard/widget/MasterTabel";

const ClassDetailsPage = () => {
  const { openModal, modalState } = useGlobalState();
  const navigate = useNavigate();
  const [details, setDetails] = useState({});
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState("Sections");
  const [isLoading, setIsLoading] = useState(true);
  const getDetailsData = async ({ isLoading = true, id } = {}) => {
    if (isLoading) setIsLoading(true);
    const res = await getClassDetails(id);
    if (res.status == "success") {
      console.log(res, "class data");
      setDetails(res.data);
    } else {
      console.log("error is " + res);
      showErrorMessages({ data: res, navigate });
    }
    if (isLoading) setIsLoading(false);
  };
  const isInitialMount = useRef(true);

  useEffect(() => {
    openModal({
      ...modalState,
      title: "Tutor",
      body: (
        <AddClassesForm
          navigate={navigate}
          refresh={async () => getDetailsData({ isLoading: false, id })}
        />
      ),
    });

    getDetailsData({ id });

    return () => {};
  }, []);

  return isLoading ? (
    <center>
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </center>
  ) : (
    <Tab.Container
      activeKey={activeTab}
      onSelect={(k) => setActiveTab(k)}
      id="profile-pills-tab"
    >
      <Row className="mb-3">
        <Row className="mb-1  pb-0">
          <Col lg="12" className="mb-0 pb-0 ">
            <Card
              className="position-relative border-0  transition-all "
              style={{ borderRadius: "1rem", transition: "0.3s" }}
            >
              <Card.Body className="p-3 px-lg-4 py-lg-3">
                <Row className="">
                  {/* Left Section */}
                  <Col className=" ">
                    <DetailsPageNavigation list={["Classes", "Details"]} />
                    <Col className="pe-0 me-0 d-flex align-items-center gap-4">
                      <div className="d-flex align-items-center gap-3 flex-column">
                        <div
                          className="rounded-3 overflow-hidden"
                          style={{
                            height: "17vh",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid rgba(0,0,0,0.05)",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                            width: "100%", // ensure container spans full width if needed
                          }}
                        >
                          <img
                            src={details?.IMAGE_URL || placeHolder}
                            alt={details["NAME"]}
                            className="w-100 h-100 object-fit-cover"
                            onError={(e) => {
                              e.target.src = placeHolder;
                            }}
                          />
                        </div>
                      </div>
                      <div className="">
                        <div className="d-flex align-items-start gap-2 mb-2">
                          <h3
                            className="mb-0 fw-bold fs-4 text-truncate"
                            style={{
                              background:
                                "linear-gradient(45deg, #2b2b2b, #4a4a4a)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                            }}
                          >
                            {details?.NAME || "No name available"}
                          </h3>
                        </div>
                        <p
                          className="text-muted mb-2 fs-6"
                          style={{
                            lineHeight: 1.5,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {details?.DESCRIPTION || "No description available"}
                        </p>
                        <Badge
                          bg=""
                          style={{
                            width: "70px",
                            padding: "2px 3px",
                            fontSize: "0.75rem",
                            fontWeight: "400",
                            backgroundColor:
                              details?.["STATUS"] === "Y"
                                ? "#e8f5e9"
                                : "#ffebee",
                            color:
                              details?.["STATUS"] === "Y"
                                ? "#2e7d32"
                                : "#c62828",
                            borderRadius: "4px",
                            textTransform: "uppercase",
                            letterSpacing: "0.4px",
                          }}
                        >
                          {details?.["STATUS"] === "Y" ? "Active" : "Inactive"}
                        </Badge>
                      </div>
                    </Col>
                    <Nav
                      as="ul"
                      className="nav-tabs mb-0 text-center mt-4"
                      data-toggle="slider-tab"
                      id="profile-pills-tab"
                      role="tablist"
                    >
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link
                          eventKey="Sections"
                          active={activeTab === "Sections"}
                        >
                          Sections
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link
                          eventKey="Student"
                          active={activeTab === "Student"}
                        >
                          Student
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link
                          eventKey="Subject"
                          active={activeTab === "Subject"}
                        >
                          Subject
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link
                          eventKey="Tutor"
                          active={activeTab === "Tutor"}
                        >
                          Tutor
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  {/* Right Section */}
                  <Col lg="3" className="h-100 ">
                    <div
                      className="d-flex flex-column gap-1 justify-content-between "
                      style={{
                        gap: "clamp(0.5rem, 2vh, 1rem)",
                        minHeight: "17vh",
                        padding: "clamp(0.5rem, 2vh, 1.5rem) 0",
                      }}
                    >
                      <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "clamp(24px, 4vw, 32px)",
                            height: "clamp(24px, 4vw, 32px)",
                            flexShrink: 0,
                          }}
                        >
                          <FiUser className="text-primary fs-6" />
                        </div>
                        <div>
                          <div
                            className={`text-dark fw-medium`}
                            style={{ fontSize: "0.875rem" }}
                          >
                            {details?.["CREATED BY"]}
                          </div>
                          {/* <small className="text-muted">{subLabel}</small> */}
                        </div>
                      </div>
                      <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "clamp(24px, 4vw, 32px)",
                            height: "clamp(24px, 4vw, 32px)",
                            flexShrink: 0,
                          }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <div
                            className={`text-dark fw-medium`}
                            style={{ fontSize: "0.875rem" }}
                          >
                            {details?.["LAST MODIFIED"]}
                          </div>
                          {/* <small className="text-muted">{subLabel}</small> */}
                        </div>
                      </div>
                      <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "clamp(24px, 4vw, 32px)",
                            height: "clamp(24px, 4vw, 32px)",
                            flexShrink: 0,
                          }}
                        >
                          <FiEdit className="text-danger fs-6" />
                        </div>
                        <div>
                          <div
                            className={`text-dark fw-medium`}
                            style={{ fontSize: "0.875rem" }}
                          >
                            {details["MODIFIED BY"]}
                          </div>
                          {/* <small className="text-muted">{subLabel}</small> */}
                        </div>
                      </div>
                      {
                        <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                          <div
                            className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                            style={{
                              width: "clamp(24px, 4vw, 32px)",
                              height: "clamp(24px, 4vw, 32px)",
                              flexShrink: 0,
                            }}
                          >
                            <MasterActions
                              actions={{
                                edit: true,
                                delete: true,
                                status: true,
                              }}
                              AddForm={
                                <AddClassesForm
                                  navigate={navigate}
                                  refresh={async () =>
                                    getDetailsData({
                                      isLoading: false,
                                      id,
                                    })
                                  }
                                />
                              }
                              methods={getMethods("Academic", "Classes")}
                              refresh={async () =>
                                await getDetailsData({
                                  isLoading: false,
                                  id,
                                })
                              }
                              deleteRow={deleteClass}
                              updateStatus={updateClassStatus}
                              updateRow={updateClass}
                              isDetailsPage={true}
                              item={details}
                            />
                          </div>
                          <div
                            className="text-dark fw-medium"
                            style={{
                              fontSize: "clamp(0.75rem, 1.5vw, 0.875rem)",
                            }}
                          >
                            Show Options
                          </div>
                        </div>
                      }
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="mt-0">
          <Col lg="12">
            <Tab.Content className="profile-content">
              <Tab.Pane eventKey="Sections">
                <MasterTable
                  getTableData={getDivisionSectionList}
                  deleteRow={deleteDivisionSection}
                  updateStatus={updateDivisionSectionStatus}
                  tab1={"Academic"}
                  classId={id}
                  AddForm={AddDivisionSectionForm}
                  tab2={"Division Sections"}
                  actions={{
                    status: true,
                    edit: true,
                    delete: true,
                  }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="Student">{/* <MasterTable /> */}</Tab.Pane>
              <Tab.Pane eventKey="Subject">
                <MasterTable
                  getTableData={getSubjectList}
                  deleteRow={deleteSubject}
                  updateStatus={updateSubjectStatus}
                  tab1={"Academic"}
                  tab2={"Subject"}
                  classId={id}
                  AddForm={AddSubjectForm}
                  actions={{
                    status: true,
                    edit: true,
                    delete: true,
                  }}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="Tutor">
                <MasterTable
                  getTableData={getTutorList}
                  deleteRow={deleteTutor}
                  updateStatus={updateTutorStatus}
                  tab1={"Academic"}
                  tab2={"Tutor"}
                  classId={id}
                  AddForm={AddTutorForm}
                  actions={{
                    status: true,
                    edit: true,
                    delete: true,
                  }}
                />
              </Tab.Pane>
            </Tab.Content>
            {
              // <MasterTable
              //   tab1={"Academic"}
              //   tab2={"Tutor"}
              //   actions={{
              //     delete: true,
              //   }}
              //   deleteRow={deleteTutorFromSubject}
              //   AddForm={AddTutorToSubject}
              //   getTableData={getTutorSubjectsList}
              //   subjectId={id}
              //   details={details}
              // />
            }
            {/* <MasterTable2
              deleteFun={deleteGroupUser}
              getList={getGroupUsersList}
              groupLevelList={groupLevelList}
              adminId={details["_GROUP ADMIN_"]["_ID"]}
              groupId={id}
              details={details}
              AddForm={AddGroupUserForm}
              refresh={() => fetchDetails({ id, isLoading: false })}
              actions={{
                delete: true,
              }}
              userId={getLocalStorageData("profileDetails")._ID}
              tab1={"User Management"}
              tab2={"Group Users"}
              isAdmin={details["_IS ADMIN"] == "Y" ? true : false}
              title={"Group Users"}
              subTitle={"User"}
              type={"GROUP"}
            /> */}
          </Col>
        </Row>
      </Row>
    </Tab.Container>
  );
};

export default ClassDetailsPage;
